<template>
  <div class="column is-paddingless contained-min-height-inter">
    <div class="tabs is-small is-marginless-bottom has-bg-white is-border-bottom">
      <ul class="has-text-weight-medium is-borderless">
        <li :class="[{'is-active':panel === 'RDVS'}, {'has-content-disabled' : panelSource === 'reminder'}]">
          <a v-if="panelSource === 'reminder'" class="has-content-disabled">
            <b class="is-uppercase">Rendez-vous</b>
          </a>
          <a @click="panel = 'RDVS'" :disabled="panelSource === 'reminder'"  :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'RDVS'}">
            <b class="is-uppercase">Rendez-vous</b>
          </a>
        </li>
        <li :class="[{'is-active':panel === 'REMINDERS'}, {'has-content-disabled' : panelSource === 'rdv'}]" class="is-border-left">
          <a v-if="panelSource === 'rdv'" class="has-content-disabled">
            <b class="is-uppercase">Rappel</b>
          </a>
          <a v-else @click="panel = 'REMINDERS'" :disabled="panelSource === 'rdv'" :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'REMINDERS'}"><b class="is-uppercase">Rappel</b></a>
        </li>
      </ul>
    </div>
    <div v-if="panel === 'RDVS'">
      <div>
        <calendar-quickview-form :source="source" @iCanSubmit="iCanSubmit" @exported='exported' @submit='submitAfter' ref="rdvComponent"></calendar-quickview-form>
      </div>
    </div>
     <div v-else-if="panel === 'REMINDERS'">
      <div>
        <new-reminder-calendar ref="reminderComponent" :source="source" @iCanSubmit="iCanSubmit" @submit='submitAfter'></new-reminder-calendar>
      </div>
    </div>
  </div>
</template>

<script>
  import CalendarQuickviewForm from '@/components/calendar/CalendarQuickviewForm'
  import NewReminderCalendar from '@/components/calendar/NewReminderCalendar'

  export default {
    name: 'NewCalendarAction',
    props: {
      source: {
        type: Object,
        default: () => {}
      }
    },
    components: {
      CalendarQuickviewForm,
      NewReminderCalendar
    },
    data () {
      return {
        panel: 'RDVS'
      }
    },
    computed: {
      panelSource () {
        if (this.source) {
          if (this.source._type === 'rdvs') {
            return 'rdv'
          } else if (this.source._type === 'reminders') {
            return 'reminder'
          }
        } else {
          return false
        }
      }
    },
    methods: {
      exported (val) {
        this.$emit('exported', val)
      },
      iCanSubmit (val) {
        this.$emit('iCanSubmit', val)
      },
      submit () {
        if (this.panel === 'REMINDERS') {
          this.$refs.reminderComponent.submit()
        } else if (this.panel === 'RDVS') {
          this.$refs.rdvComponent.submit()
        }
      },
      submitAfter (val) {
        this.$emit('submit', {val})
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/quickview/NewCalendarAction.vue